export const SESSION_USER_KEY = 'planit_user'
export const SESSION_TOKEN_KEY = 'planit_token'
export const SESSION_REFRESH_TOKEN_KEY = 'planit_refresh_token'
